/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Modal from '/client/src/components/Modal';
import TagsInput from 'react-tagsinput';
import Loader from '/client/src/components/Loader';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { POST, PUT, GET } from '/client/src/api';
import { timeerOffModal } from '/client/src/constants/';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import VIPValidator from './modalDataValidation';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleShowModal: (boolean) => void,
  handleAddVipcode: () => void,
  isOpenModalFor: null | string,
  selectedRow?: {
    group_id: number,
    codes: []
  },
  vip_codes: [],
  eventId: number | string,
  defaultContainerContext: {
    handleShowSystemDialog: () => void
  }
};
class EventPageDetailVIPCodesModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = EventDetailContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      isLoaded: false,
      selectedCodes: _.get(props.selectedRow, 'codes', []),
      limitNumberOn: false,
      limitNumber: 0,
      limitCheckout: 0,
      limitCheckoutOn: false,
      avaliableWindowOn: false,
      selectedDVType: '$',
      selectedRow: props.selectedRow,
      tickets: [],
      amount: '',
      percentage: '',
      use_percentage: false,
      isLocked: false,
      applied_to_all_tickets: false,
      applied_to_ticket_id: [],
      sponsors: [],
      sponsorId: null,
      sponsorsIsLoaded: props.isOpenModalFor === 'Edit',
      isShowSponsors: false,
      applied_to_ticket_temp_id: [],
      contextPriceTickets: [],
      isValidCode: true
    };

    this.buttonRef = React.createRef();
  }

  componentDidMount = async () => {
    const { isOpenModalFor, eventId } = this.props;

    this.setState({ contextPriceTickets: this.context.eventDetail.tickets });

      setTimeout(() => {
        // eslint-disable-next-line
        $('body').on('click', function (e: any) {
          if (!$('.dropdown-tickets').is(e.target)
            && $('.dropdown-tickets').has(e.target).length === 0
            && $('.open').has(e.target).length === 0
          ) {
            $('.dropdown-tickets').removeClass('open');
          }
        });
      }, 1000);

    if (isOpenModalFor !== 'Edit') {
      const { result } = await GET(`/api/v1/1/sponsors/byevent/${eventId}`);

      this.setState({
        sponsors: _.map(result, (r: {}): {} => {
          // HACK (invalid response from API)
          return {
            ...r,
            label: r.name,
            value: r.name
          };
        }),
        sponsorsIsLoaded: true
      });
    }
  }

  handleClose = (): any => {
    const { handleShowModal } = this.props;

    handleShowModal(false);
  };

  handleChangeCheckbox = (e: any, status: boolean) => {
    const name = e.target.name;

    this.setState({
      [name]: status
    });
  };

  hadleChangeDVType = (value: string) => {
    this.setState({
      selectedDVType: value,
      use_percentage: value === '%'
    });
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      const { result: { vip_codes, tickets, sponsors } } = response.data;
      const isEdit = this.props.isOpenModalFor === 'Edit';

      let appliedTickets = [];

      if (vip_codes[0].applied_to_all_tickets) {
        appliedTickets = _.map(isEdit ? tickets : this.state.contextPriceTickets, (t: {}): number => t.id);
      } else {
        appliedTickets = isEdit ? vip_codes[0].applied_to_ticket_id : [];
      }

      this.setState({
        isLoaded: true,
        ids: _.map(vip_codes, (d: {}): {} => ({ id: d.id, code: d.coupon_code })),
        group_id: vip_codes[0].group_id,
        applied_to_ticket_temp_id: appliedTickets,
        applied_to_ticket_id: appliedTickets,
        applied_to_all_tickets: vip_codes[0].applied_to_all_tickets,
        limitNumberOn: vip_codes[0].is_enable_limitation_times,
        limitNumber: vip_codes[0].limitation_times,
        limitCheckoutOn: vip_codes[0].is_enable_usage_per_checkout,
        limitCheckout: vip_codes[0].usage_per_checkout,
        avaliableWindowOn: vip_codes[0].is_enable_expiration,
        beginTimeUTC: vip_codes[0].begin_time_utc,
        endTimeUTC: vip_codes[0].end_time_utc,
        selectedDVType: vip_codes[0].use_percentage ? '%' : '$', // TODO
        tickets,
        amount: vip_codes[0].amount / 100,
        percentage: vip_codes[0].percentage,
        use_percentage: vip_codes[0].use_percentage,
        sponsorId: vip_codes[0].sponsor_id || null,
        isShowSponsors: vip_codes[0].sponsor_id,
        sponsors: _.map(sponsors, (s: {}): {} => {
          return {
            ...s,
            value: s.id,
            label: s.name
          };
        })
      });
    }
  }

  handleChange = (codes: []) => {
    const _codes = _.filter(codes, (i: string): boolean => i.trim() !== '');
    const caseInsensitiveUniqueCodes = _codes.map(s => s.toLowerCase()).reduce((map, s, i) =>
    map.get(s) ? map : map.set(s, _codes[i]), new Map());

    if (_.size(_codes) < 10) {
      this.setState({
        selectedCodes: [...caseInsensitiveUniqueCodes.values()],
        isValidCode: true
      });
    }
  };

  handleChangeInput = (e: any) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  }

  handleSelectAllTickets = () => {
    const {
      tickets
    } = this.state;

    const data = _.map(
      this.props.isOpenModalFor === 'Edit' ? tickets : this.state.contextPriceTickets,
      (t: {}): number => t.id);

    this.setState({
      applied_to_all_tickets: true,
      applied_to_ticket_id: data,
      applied_to_ticket_temp_id: data
    });
  }

  setApliedTicketsTickets = (data: [], isEdit: boolean) => {
    // HACK incorrect data from API
    const _tickets = isEdit ? this.state.tickets : this.state.contextPriceTickets;

    this.setState({
      applied_to_ticket_id: data,
      applied_to_ticket_temp_id: data,
      applied_to_all_tickets: _.size(data) === _.size(_tickets)
    });
  }

  getTicketsNameArr = (data: []): [] => {
    const isEdit = this.props.isOpenModalFor === 'Edit';

    const _tickets = isEdit ? this.state.tickets : this.state.contextPriceTickets;

    return _.map(data, (tid: {}): string => {
      const _ticket = _.find(_tickets, (_t: {}): {} => _t.id === tid);

      return _.get(_ticket, 'name', '');
    });
  }

  defaultPasteSplit(data) {
    return data.split(/[\n\r\s\,]+/).map(d => d.trim());
  }

  content = (): React.Element<'div'> => {
    const {
      tickets,
      applied_to_ticket_temp_id,
      applied_to_ticket_id,
      isValidCode
    } = this.state;

    const isEdit = this.props.isOpenModalFor === 'Edit';
    const att = isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12" style={{ marginBottom: '1.5rem', zIndex: 9 }}>

            <label htmlFor="">VIP codes</label>
            <TagsInput
              value={this.state.selectedCodes}
              onChange={this.handleChange}
              inputProps={{
                placeholder: ''
              }}
              addKeys={[9, 13, 32, 188]}
              addOnPaste
              addOnBlur
              pasteSplit={this.defaultPasteSplit}
              onlyUnique
              validationRegex={/^[A-z0-9-+.]{0,70}$/}
              onValidationReject={(): void => this.setState({ isValidCode: false })}
            />

            {!isValidCode &&
              <span className='EventPageDiscountModal-overlimit'>
                VIP code name has a 70 characters limit and must not contain special characters (e.g. “!#$%#$^*")
              </span>
            }
          </div>

          <div className="col-md-12">
            <label>Applies to</label>
            <div className="dropdown dropdown-tickets">
              <button
                className="btn btn-default dropdown-toggle"
                style={{ width:'100%' }}
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => {
                  $('.dropdown-tickets').toggleClass('open');
                }}
              >
                <div style={{ cursor: 'pointer' }}>
                  <span>
                    {_.size(att) === _.size(isEdit ?
                      tickets : this.state.contextPriceTickets) ?
                      <>All Tickets</> :
                      <>{
                        _.size(att) === 1 ?
                          <>{_.map(isEdit ?
                            tickets : this.state.contextPriceTickets, (t: {}): string => {
                            if (t.id.toString() === (att)[0].toString()) {
                              return t.name;
                            }
                          })}</> :
                          <>
                            {_.size(att) === 0 ?
                              <></> :
                              <>{_.size(this.state.applied_to_ticket_id)} tickets</>
                            }
                          </>
                      }</>
                    }
                  </span>
                  <span className="caret-right">
                    <span className="caret" />
                  </span>
                </div>
              </button>
              <ul className="dropdown-menu" role="menu" style={{ width:'100%' }}>
                <li onClick={this.handleSelectAllTickets}>
                  <a
                    style={{
                      cursor: 'pointer',
                      padding: '6px 20px'
                    }}
                  >All Tickets</a>
                </li>
                <li role="separator" className="divider" />
                { // HACK tickets : this.state.contextPriceTickets -> incorrect response from API
                  _.map(isEdit ?
                  tickets : this.state.contextPriceTickets, (t: {}, ti: number): React.Element<'li'> => {
                  const appliedTickets = isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id;

                  return (
                    <li key={`${t.id}-${ti}`}>
                      <a title={t.name}>
                        <label className="icheckbox" style={{ margin: '6px 0' }}>
                          <input
                            checked={_.indexOf(appliedTickets, t.id) !== -1}
                            type="checkbox"
                            id={t.id}
                            onChange={(e: any) => {
                              const isChecked = e.target.checked;

                              let arr;

                              if (isChecked) {
                                arr = [...appliedTickets, t.id];
                              } else {
                                arr = _.remove(appliedTickets, (n: string): string => {
                                  return n.toString() !== t.id.toString();
                                });
                              }

                              this.setApliedTicketsTickets(_.compact(arr), isEdit);
                            }}
                          />
                          <i className="icheckbox-icon" />
                          <span data-bind="text:name">{t.name}</span>
                        </label>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

          </div>
        </div>

        <br/>
      </div>
    );
  }

  handleSaveCodes = async (setStatus: (string) => void, isOpenModalFor: string): any => {
    const isEdit = isOpenModalFor === 'Edit';

    const {
      isLocked,
      ids,
      selectedCodes,
      amount,
      applied_to_all_tickets,
      applied_to_ticket_id,
      applied_to_ticket_temp_id,
      group_id,
      limitNumberOn,
      limitNumber,
      limitCheckoutOn,
      limitCheckout,
      selectedDVType,
      avaliableWindowOn,
      beginTimeUTC,
      endTimeUTC,
      sponsorId
    } = this.state;

    const {
      eventId,
      vip_codes,
      defaultContainerContext,
      selectedRow
    } = this.props;

    if (isLocked || !eventId) {
      return false;
    }

    const ErrorCallback = (action: string, error: any) => {
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: `Can't ${action} codes`
      });

      setStatus('error');
      if (error) {
        console.error(error);
      }

      setTimeout(() => {
        setStatus('');
      }, timeerOffModal * 2);
    };
    const groupId = (_.max(_.map(vip_codes, (d: {}): number => d.group_id)) || 0) + 1;
    const bTime = beginTimeUTC ? moment(beginTimeUTC).utc().format() : moment().utc().format();
    const sTime = endTimeUTC ? moment(endTimeUTC).utc().format() : moment().utc().format();
    const _applied_to_tickets = this.getTicketsNameArr(isEdit ? applied_to_ticket_id : applied_to_ticket_temp_id);

    const _row = {
      'amount': amount * 100,
      applied_to_all_tickets,
      applied_to_ticket_id,
      applied_to_ticket_temp_id,
      'applied_to_tickets': _applied_to_tickets,
      'group_id': isEdit ? group_id : groupId,
      'is_reveal_ticket': false,
      'is_enable_limitation_times': limitNumberOn,
      'limitation_times': limitNumber,
      'is_disabled': false,
      'percentage': selectedDVType === '%' ? amount : 0,
      'use_percentage': selectedDVType === '%',
      'is_enable_usage_per_checkout': limitCheckoutOn,
      'usage_per_checkout': limitCheckout,
      'is_enable_expiration': avaliableWindowOn,
      'end_time_utc': sTime,
      'begin_time_utc': bTime,
      'sponsor_id': sponsorId
    };

    const data = {
      group_id: isEdit ? group_id : groupId,
      'vip_codes': _.map(selectedCodes, (d: string, i: number): {} => {
        return {
          ..._row,
          'coupon_code': d,
          'id': isEdit ? _.get(
            _.find(
              ids,
              (item: string): {} => item.code === d),
            'id', -1000 - group_id - i) : -1000 - groupId - i
        };
      })
    };

    const isValid = VIPValidator({
      _applied_to_tickets,
      applied_to_all_tickets,
      codes: selectedCodes,
      vip_codes,
      selectedRow
    }, defaultContainerContext.handleShowSystemDialog);

    if (_.size(isValid)) {
      const reapetedCode = isValid.find(x => x.key === 'codeExist');

      if (reapetedCode) {
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogCallback: () => {
          defaultContainerContext.handleShowSystemDialog(false);
        },
        systemDialogCallbackActions: ['Ok'],
        systemDialogContent: (
          <>
          Can not save code. VIP codes can not be repeated. Make sure the following is used only once: <br/>
          <li>{reapetedCode.codes[0]}</li>
          </>
        )
      });
      return false;
    }
      defaultContainerContext.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Hmmm...',
        systemDialogCallback: () => {
          defaultContainerContext.handleShowSystemDialog(false);
        },
        systemDialogCallbackActions: ['Ok'],
        systemDialogContent: (<>
          You must check at least one:
          <ul
            style={{
              listStyleType: 'circle',
              listStylePosition: 'inside',
              marginTop: '1rem',
              marginLeft: '1rem',
              fontSize: '1rem'
            }}
          >
            {_.map(isValid, (f: {key: string}, fi: number): string => {
              return (
                <li key={`DiscountValidator-${fi}`}>
                  {f.key === 'appliedToTickets' && 'Ticket must be selected'}
                  {f.key === 'codeValidation' && 'VIP codes'}
                </li>
              );
            })}
          </ul>
        </>)
      });

      return false;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    if (!isEdit) {
      try {
        // TODO Change to VIP endpoint
        const { result, success } = await POST(`/api/v1/1/vipcodes/${this.props.eventId}/add`, data);

        if (success) {
          this.setState({
            isLocked: false
          }, () => {
            if (!_.size(result.vip_codes)) {
              setStatus('error');

              this.setState({
                isLocked: false
              });
              ErrorCallback('create');
            } else {
              setStatus('success');

              defaultContainerContext.handleShowSystemDialog(true, {
                systemDialogType: 'success',
                systemDialogTitle: 'Great!',
                systemDialogContent: 'VIP codes was added'
              });

              this.props.handleAddVipcode(result.vip_codes, !isEdit ? 'add' : 'update');
            }

            this.handleClose();
          });
        }
      } catch (error) {
        this.setState({
          isLocked: false
        }, () => {
          ErrorCallback('create', error);
        });
      }
    } else {
      try {
        // TODO Change to VIP endpoint
        const { success } = await PUT(`/api/v1/1/vipcodes/${this.props.eventId}/update`, data);

        if (success) {
          this.setState({
            isLocked: false
          }, () => {
            setStatus('success');

            defaultContainerContext.handleShowSystemDialog(true, {
              systemDialogType: 'success',
              systemDialogTitle: 'Great!',
              systemDialogContent: 'VIP code was update'
            });

            this.props.handleAddVipcode(data.vip_codes, !isEdit ? 'add' : 'update');

            this.handleClose();
          });
        }
      } catch (error) {
        this.setState({
          isLocked: false
        }, () => {
          ErrorCallback('update', error);
        });
      }
    }
  };

  render(): React.Element<'div'> {
    const { isOpen, isOpenModalFor, eventId, selectedRow } = this.props;

    return (
      <Modal
        overflow='visible'
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div className={`
            modal-dialog
            customModal
            EventPageDetailCustomersModal
            EventPageDiscountModal
            modal-table-filter
          `} role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>{isOpenModalFor} VIP codes</span>
              </h4>
            </div>
            <div className="modal-body" style={{ padding: '2rem 0 1rem', minHeight: '100px' }}>

              {isOpenModalFor === 'Create' ?
                <>{this.content()}</> :
                <>
                  <Loader
                    url={`/api/v1/1/vipcodes/${eventId}/${selectedRow.group_id}`} // TODO change VIP endpoint
                    onLoaded={this.handleLoaded}
                  >
                    {this.state.isLoaded && <>{this.content()}</> }
                  </Loader>
                </>
              }

            </div>
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Cancel</button>
              <span className='custom-pb-container'>
                <BtnLoader
                  label={`${isOpenModalFor} codes`}
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSaveCodes(setStatus, isOpenModalFor);
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailVIPCodesModal;
